module.exports = __webpack_public_path__ + "static/media/468x60_0068_en.9909f331.jpg";